import { render, staticRenderFns } from "./DriverStandingsTable.vue?vue&type=template&id=0d088b9b&"
import script from "./DriverStandingsTable.vue?vue&type=script&lang=js&"
export * from "./DriverStandingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports